import { axiosRequestHelper, RequestHelperResult } from './endpoint-helpers';

export const deleteTeamInvite = (
    teamId: string,
    inviteId: string,
    inviteResponse: 'Accept' | 'Reject'
): Promise<RequestHelperResult<undefined>> =>
    axiosRequestHelper('DELETE', `/api/teams/${teamId}/invites/${inviteId}?acceptInvite=${inviteResponse}`);
